import request from '@/utils/request'

export function fetchList (query) {
  return request({
    url: '/card/api/client_mode/index',
    method: 'get',
    params: query
  })
}

export function fetchClientMethods (id) {
  return request({
    url: '/card/api/client_mode/methods',
    method: 'get',
    params: { id }
  })
}

export function updateClientMethod (id, methods) {
  return request({
    url: '/card/api/client_mode/method_update',
    method: 'post',
    params: { id },
    data: { methods }
  })
}

export function insert (data) {
  return request({
    url: '/card/api/client_mode/insert',
    method: 'post',
    data
  })
}

export function update (data) {
  return request({
    url: '/card/api/client_mode/update',
    method: 'post',
    data
  })
}

export function remove (id) {
  return request({
    url: '/card/api/client_mode/delete',
    method: 'post',
    params: { id }
  })
}
export function deleteMethod (data) {
  return request({
    url: '/card/api/client_mode/delete_method',
    method: 'post',
    data
  })
}

export function bindMethod (data) {
  return request({
    url: '/card/api/client_mode/bind',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/card/api/client_mode.js